const map = {
	"./digital-payment.webp": 28181,
	"./e-commerce-software.webp": 92779,
	"./finance-payment.webp": 37255,
	"./finance-software.webp": 68422,
	"./healthcare-payment.webp": 14502,
	"./healthcare-software.webp": 18413,
	"./hhrr-payment.webp": 3873,
	"./ico-bag.png": 38246,
	"./ico-hammer.png": 74676,
	"./ico-heart.png": 14748,
	"./ico-puzzle.png": 58246,
	"./ico-statistics.png": 40327,
	"./ico-store.png": 38091,
	"./law-payment.webp": 96677,
	"./legal-issues-software.webp": 69852,
	"./marketplaces-software.webp": 82880,
	"./startups-payment.webp": 76327
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 50312;